import React from "react";
import { ConditionsBlock } from "@/components/Conditions/ConditionsBlock";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { InstructionBlock } from "@/components/InstructionBlock/InstructionBlock";
import { EarningsBlock } from "@/components/Balance/EarningsBlock";
import { InviteFriendBlock } from "@/components/InviteFriend/InviteFriendBlock";
import { useUserInfoStore } from "@/store/userInfoStore";
import { ActiveReferals } from "@/components/ReferalsLists/ActiveReferals";
import { UnregisteredReferals } from "@/components/ReferalsLists/UnregisteredReferals";
import { MissedReferals } from "@/components/ReferalsLists/MissedReferals";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import { CompletedReferals } from "@/components/ReferalsLists/CompletedReferals";
import { ReferralMultiplierBanner } from "@/components/ReferralMultiplierBanner/ReferralMultiplierBanner";
import { BloggerContestBanner } from "@/components/BloggerContestBanner/BloggerContestBanner";
import { IDS } from "./idsForEats";
import { AdviceBlock } from "../AdviceBlock/AdviceBlock";

const InviteBlock = () => {
  const yandexId = useUserInfoStore((s) => s.yandexId);
  const serviceType = useUserInfoStore((s) => s.serviceType);
  const { eatsLinkUnlocked } = useReferalsDataContext();
  const isServiceTypeEats = serviceType === "eats";

  if (serviceType === "delivery" && (eatsLinkUnlocked || IDS.has(yandexId))) {
    return (
      <>
        <InviteFriendBlock variant="eats" />
        <InviteFriendBlock variant="delivery" />
        <InviteFriendBlock variant="taxi" />
      </>
    );
  }

  if (serviceType === "taxi" && eatsLinkUnlocked) {
    return (
      <>
        <InviteFriendBlock variant="taxi" />
        <InviteFriendBlock variant="eats" />
        <InviteFriendBlock variant="delivery" />
      </>
    );
  }

  return isServiceTypeEats ? (
    <InviteFriendBlock variant="eats" />
  ) : (
    <>
      <InviteFriendBlock variant="delivery" />
      <InviteFriendBlock variant="taxi" />
    </>
  );
};

export const InviteReferralsSection = () => {
  const { activeReferals, userStatus } = useReferalsDataContext();
  const haveActiveReferals =
    activeReferals.results && activeReferals.results.length > 0;

  return (
    <>
      {!haveActiveReferals && <InstructionBlock isBlockOpen />}

      <AdviceBlock />

      <FlexColumn gap={14}>
        <InviteBlock />
      </FlexColumn>

      {userStatus?.capabilities.blogger_competition && <BloggerContestBanner />}

      <ReferralMultiplierBanner />
      <ConditionsBlock />
      <EarningsBlock />

      <ActiveReferals />
      <UnregisteredReferals />
      <MissedReferals />
      <CompletedReferals />
    </>
  );
};
